export default ({ props, monitor }) => props.currentBoardId !== props.elementId;
